import { render, staticRenderFns } from "./ExpansionPanelTemplate.vue?vue&type=template&id=6b422d8a"
import script from "./ExpansionPanelTemplate.vue?vue&type=script&lang=ts"
export * from "./ExpansionPanelTemplate.vue?vue&type=script&lang=ts"
import style0 from "./ExpansionPanelTemplate.vue?vue&type=style&index=0&id=6b422d8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports